module.exports = __webpack_public_path__ + "static/img/ydh2-price.9f480d29.png";